import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { Spinner } from 'component/Spinner'
import { Vertical } from 'component/Vertical'
import { UnavailablePage } from 'feature/page/UnavailablePage/UnavailablePage'
import { useDynamicAppStyles } from 'hook/useDynamicAppStyles'
import { useEffectOnce } from 'hook/useEffectOnce'
import { usePreventZoom } from 'hook/usePreventZoom'
import { observer } from 'mobx-react-lite'
import { Banner } from 'page/catalog/Banner/Banner'
import { BasicCarouselWelcome } from 'page/catalog/BasicCarouselWelcome/BasicCarouselWelcome'
import { BasicHeader } from 'page/catalog/BasicHeader/BasicHeader'
import { BasicUserPane } from 'page/catalog/BasicUserPane/BasicUserPane'
import { BasicWelcomePage } from 'page/catalog/BasicWelcomePage/BasicWelcomePage'
import { BoutiqueHeader } from 'page/catalog/BoutiqueHeader/BoutiqueHeader'
import { BoutiqueUserPane } from 'page/catalog/BoutiqueUserPane/BoutiqueUserPane'
import { Content } from 'page/catalog/Content/Content'
import { StandContent } from 'page/catalog/Content/StandContent'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { EmployeeBoutiquePage } from 'page/catalog/EmployeeBoutiquePage/EmployeeBoutiquePage'
import { Header } from 'page/catalog/Header/Header'
import { Modals } from 'page/catalog/Modals/Modals'
import { StandHeader2 } from 'page/catalog/StandHeader/StandHeader2'
import { StandUserPane } from 'page/catalog/StandUserPane/StandUserPane'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { WelcomeSochiPage } from 'page/catalog/WelcomeSochiPage/WelcomeSochiPage'
import { WidgetBlur } from 'page/catalog/WidgetBlur/WidgetBlur'
import { useState } from 'react'
import { opt } from 'store/opt'
import css from './CatalogPage.module.scss'

export const CatalogPage = observer(() => {
  const demo = useDemo()
  const { error, ready, welcome, stand, basic, boutique, dark, welcome_sochi } = demo
  const compact = stand && !demo.product.logo
  const [lazy, setLazy] = useState(true)
  const className = clsx(
    css.root,
    !stand && css.pad,
    boutique && css.boutique,
    stand && css.panel,
    opt.sochi && css.sochi,
    compact && css.compact
  )

  useDynamicAppStyles(demo.data.slug)

  usePreventZoom(stand)

  useEffectOnce(() => {
    comboCartStore.init()
  })

  useEffectOnce(() => {
    setTimeout(() => {
      setLazy(false)
    }, 10)
  })

  useEffectOnce(() => {
    const tg = 'TelegramWebviewProxy' in window

    document.body.classList.add(css.scroll)
    document.body.classList.toggle('stand', stand)
    document.body.classList.toggle(css.flat, stand)
    document.body.classList.toggle(css.tg, tg)
    document.body.classList.toggle(css.vars, stand)
    document.body.classList.toggle(css.stand, stand && !basic)
    document.body.classList.toggle(css.basic, stand && basic)
    document.body.classList.toggle('theme-dark', dark)
    document.body.classList.toggle(css.boutique, boutique)
    document.body.classList.toggle(css.widget, stand)
    document.body.classList.toggle(css.sochi, opt.sochi)

    return () => {
      document.body.classList.remove(css.scroll)
      document.body.classList.remove('stand')
      document.body.classList.remove(css.flat)
      document.body.classList.remove(css.tg)
      document.body.classList.remove(css.vars)
      document.body.classList.remove(css.stand)
      document.body.classList.remove(css.basic)
      document.body.classList.remove('theme-dark')
      document.body.classList.remove(css.boutique)
      document.body.classList.remove(css.widget)
      document.body.classList.remove(css.sochi)
    }
  })

  if (lazy) return null
  if (error) return <UnavailablePage stand={stand} />
  if (welcome_sochi) return <WelcomeSochiPage />
  if (welcome) return welcome.carousel ? <BasicCarouselWelcome /> : <BasicWelcomePage />
  if (boutique && !employee.user) return <EmployeeBoutiquePage />

  return (
    <Vertical className={className} tall>
      {boutique ? <BoutiqueHeader /> : basic ? <BasicHeader /> : stand ? <StandHeader2 /> : <Header />}
      <Banner top />
      {!ready ? (
        <Space height={400} wide center>
          <Spinner />
        </Space>
      ) : stand ? (
        <StandContent />
      ) : (
        <Content />
      )}
      {stand && <WidgetBlur />}
      {basic ? <BasicUserPane /> : stand ? <StandUserPane /> : boutique ? <BoutiqueUserPane /> : null}
      <Banner />
      <Modals />
    </Vertical>
  )
})
